import React from "react";
import { StyleSheet, View, TouchableOpacity, FlatList } from "react-native";
import { connect } from "react-redux";
import { colors } from "../../../const";
import { PrimaryTitle } from "../../../components/labels";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { changeLanguage } from "../../../action"
import Header from "../../../components/Header";
import localize from "../../../localize";

class AppLanguage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [
                { title: "English", value: "eng" },
                { title: "中文", value: "ch" }
            ]
        }
    }

    _language = (lng) => {
        this.props.changeLanguage(lng);
    }

    renderItem = ({ item }) => {
        return (
            <TouchableOpacity
                style={styles.item}
                onPress={() => this._language(item.value)}
                activeOpacity={1}
            >
                <PrimaryTitle>
                    {item.title}
                </PrimaryTitle>
                {
                    this.props.language === item.value && (<Icon icon={faCheck} color={colors.green} style={{ position: "static", fontSize: 18 }} />)
                }
            </TouchableOpacity>
        )
    }

    render() {
        const { data } = this.state;
        const { language } = this.props;
        return (
            <View style={styles.root}>
                <Header title={localize.Languages} goBack={() => this.props.history.goBack()} />
                <FlatList
                    data={data}
                    extraData={language}
                    keyExtractor={(item, index) => item.value}
                    renderItem={this.renderItem}
                />
            </View>
        )
    }

}

function mapStateToProps({ setting }) {
    return {
        language: setting.app_language
    }
}

export default connect(mapStateToProps, { changeLanguage })(AppLanguage);

const styles = StyleSheet.create({
    root: {
        flex: 1,
        backgroundColor: colors.app_background
    },
    item: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingHorizontal: 15,
        paddingVertical: 18,
        borderBottomColor: colors.lightGray,
        borderBottomWidth: 0.4
    }
})